var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tickets-chat',{attrs:{"loader":_vm.loader,"items":_vm.items,"fields":_vm.fields,"sort-key":_vm.sortKey,"sort-type":_vm.sortType,"additional-data":_vm.additionalData},on:{"onSearch":_vm.search}})}
var staticRenderFns = []

export { render, staticRenderFns }